<template>
	<el-row class="sense-container">
		<div class="sense-header">
			<div class="sense-header-box clearfix">
				<h1 class="fl"></h1>
				<div class="sense-nav fl">
					<el-menu					    
					    class="el-menu-demo"
					    mode="horizontal"					 
					    background-color="#001529">
					    <el-menu-item index="1" v-show="package_buy">
					    	<router-link tag="span" to="/buy" class="tag-list">购买套餐</router-link>					    	
					    </el-menu-item>
						<el-menu-item index="2" v-show="package_view">
							<router-link tag="span" to="/myPackage" class="tag-list">我的套餐</router-link>	
						</el-menu-item>
						<el-menu-item index="3" v-show="order_view">
							<router-link tag="span" to="/order" class="tag-list">我的订单</router-link>	
						</el-menu-item>
					</el-menu>
				</div>
			</div>
		</div>
		<div class="sense-content">			
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
		</div>
		<div class="sense-footer">
			北京深盾科技股份有限公司 &copy;
			<a target="_blank" href="http://www.beian.miit.gov.cn">京ICP备16009104号</a>
			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025663">
				<img src="../../static/img/keep-record.png">京公网安备 11010802025663号</em>
			</a>
		</div>
	</el-row>
</template>

<script>
	import { ajax } from '../api/api.js'
	
	export default {
		data() {
			return {
				package_buy: false,
				package_view: false,
				order_view: false			
			}
		},
		methods: {
			loadNav() {
				let url = '/getPrivilegesForWeb.do';
				let param = {};

				ajax(url, param).then(response => {
					if (response.code == 0) {
						if (response.data.package_buy) {
							this.package_buy = true;
						};
						if (response.data.package_view) {
							this.package_view = true;
						};
						if (response.data.order_view) {
							this.order_view = true;
						};
					} else {
						this.$message({
							message: response.desc,
							type: 'warning'
						});
					};				
				});		
			},
		},
		mounted() {
			this.loadNav();
		}
	}

</script>

<style lang="scss">

	$common-color: #409EFF;
	
</style>


// WEBPACK FOOTER //
// Home.vue?65bfdc3f